import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

const Private = ({ children }) => {
  const isAuthenticated = localStorage.getItem('token');
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }
  return children;
};

Private.propTypes = {
  children: PropTypes.element,
};

export default Private;
